// Skill groups. Each item carries a brand color used for its chip dot/accent.
export const skillGroups = [
  {
    category: 'Mobile',
    items: [
      { name: 'Flutter', color: '#54C5F8' },
      { name: 'Dart', color: '#3AB0E6' },
      { name: 'RevenueCat', color: '#FF7A2F' },
    ],
  },
  {
    category: 'Backend',
    items: [
      { name: 'Python', color: '#4B8BBE' },
      { name: 'FastAPI', color: '#16A394' },
      { name: 'Next.js', color: '#E6E6E6' },
      { name: 'WebSocket', color: '#FF9D5C' },
      { name: 'Firebase', color: '#FFCA28' },
    ],
  },
  {
    category: 'AI / ML',
    items: [
      { name: 'LLMs', color: '#19C37D' },
      { name: 'Computer Vision', color: '#7C5CFF' },
      { name: 'Voice AI', color: '#FF7A2F' },
    ],
  },
  {
    category: 'Robotics / Hardware',
    items: [
      { name: 'Raspberry Pi', color: '#C7204C' },
      { name: 'Arduino', color: '#23A1A8' },
      { name: 'Sensors', color: '#FF9D5C' },
    ],
  },
  {
    category: 'Tooling',
    items: [
      { name: 'Git', color: '#F05032' },
      { name: 'REST', color: '#FF7A2F' },
      { name: 'OSRM', color: '#7C5CFF' },
      { name: 'Cloud Functions', color: '#FFCA28' },
    ],
  },
];
